export default {
	"activate.Expired": "已過期",
	"activate.HasBeenEffective": "已生效",
	"activate.NotInEffect": "未生效",
	"activate.all": "全部",
	"activate.LoggedOut": "已註銷",
	"activate.NotRedeemed": "未兌換",
	"activate.Redeemed": "已兌換",
	"activate.CopiedSuccessfully": "已成功複製！",
	"activate.ReplicationIsNotSupported": "不支援複製",
	"activate.TheUserDoesNotHaveActivationCodeData": "該用戶沒有啟動碼相關數據",
	"activate.ParameterError": "參數錯誤！",
	"activate.TheVerificationCodeHasExpiredPleaseGetTheVerificationCodeAgain": "驗證碼已過期，請重新獲取驗證碼",
	"activate.TheUsersMobilePhoneNumber": "用戶手機號",
	"activate.ActivationCode": "啟動碼",
	"activate.copy": "複製",
	"activate.RedemptionStatus": "兌換狀態",
	"activate.EffectiveStatus": "生效狀態",
	"activate.TheOrderNumber": "訂單號",
	"activate.RedeemGoods": "兌換商品",
	"activate.RedemptionAddress": "兌換位址"
}